import React from "react";
import NYTimes from "./NYTimes";

const News = () => {

  return (
    <div className="news">
      <h2 className="news-title">Latest Headlines</h2>
      <div className="nytimes">
        <h3 className="source">Source: New York Times</h3>
        <NYTimes />
      </div>
    </div>
  )
}

  
export default News;